export default __webpack_public_path__ + "static/media/on-9.1530dd93.png";